
import { Link } from 'react-router-dom';

const CTASection = () => {
  return (
    <section 
      className="relative py-32 overflow-hidden"
      style={{
        backgroundImage: `url('https://public.readdy.ai/ai/img_res/49682190fc1e05c4f2abc82108d90967.jpg')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat'
      }}
    >
      <div className="absolute inset-0 bg-[#3a3a3a]/80"></div>
      
      <div className="relative z-10 container-custom section-padding text-center">
        <div className="max-w-4xl mx-auto animate-fade-in">
          <h2 className="text-5xl lg:text-6xl font-light museo-font text-white mb-8">
            ¿Lista para formar parte de{' '}
            <span className="text-[#ffb7b4] font-medium whitespace-nowrap">altta community</span>?
          </h2>
          
          <p className="text-xl text-white/90 mb-12 leading-relaxed max-w-3xl mx-auto">
            Únete a un ecosistema donde la elegancia contemporánea y la autenticidad 
            se convierten en las mejores herramientas de comunicación para marcas exigentes.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <Link 
              to="/altta-community" 
              className="bg-[#ffb7b4] text-[#3a3a3a] hover:bg-[#ff9f9c] transition-all duration-300 px-12 py-4 text-lg font-medium tracking-wide whitespace-nowrap cursor-pointer"
            >
              Explorar Talento
            </Link>
            <Link 
              to="/contacto" 
              className="border-2 border-white text-white hover:bg-white hover:text-[#3a3a3a] transition-all duration-300 px-12 py-4 text-lg font-medium tracking-wide whitespace-nowrap cursor-pointer"
            >
              Contactar Ahora
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
